module.exports = __webpack_public_path__ + "static/media/Logo.f5e46e67.png";